import { render, staticRenderFns } from "./familyEventStatisticsComp.vue?vue&type=template&id=14bc1012&scoped=true"
import script from "./familyEventStatisticsComp.vue?vue&type=script&lang=js"
export * from "./familyEventStatisticsComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bc1012",
  null
  
)

export default component.exports